import gql from 'graphql-tag'

export const GET_TAG_TYPES = gql`
  query {
    tagTypes {
      id
      label
      slug
      tags {
        id
        label
        slug
      }
    }
  }
`

export const CREATE_TAG_TYPE = gql`
  mutation ($label: String!, $slug: String!) {
    createTagType(label: $label, slug: $slug) {
      id
      label
      slug
    }
  }
`

export const DELETE_TAG_TYPE = gql`
  mutation ($id: ID!) {
    deleteTagType(id: $id)
  }
`

export const CREATE_TAG = gql`
  mutation ($tagTypeId: ID!, $label: String!, $slug: String!) {
    createTag(tagTypeId: $tagTypeId, label: $label, slug: $slug) {
      id
      label
      slug
      tagType {
        id
        label
        slug
      }
    }
  }
`

export const DELETE_TAG = gql`
  mutation ($id: ID!) {
    deleteTag(id: $id)
  }
`

export const ADD_TAG_TO_EMAIL_TEMPLATE = gql`
  mutation ($id: ID!, $tagId: ID!) {
    addTagToSimulationEmailTemplate(id: $id, tagId: $tagId) {
      id
      tags {
        id
        label
        tagType {
          id
          label
        }
      }
    }
  }
`

export const REMOVE_TAG_FROM_EMAIL_TEMPLATE = gql`
  mutation ($id: ID!, $tagId: ID!) {
    removeTagFromSimulationEmailTemplate(id: $id, tagId: $tagId) {
      id
      tags {
        id
        label
        tagType {
          id
          label
        }
      }
    }
  }
`

export const ADD_TAG_TO_LANDING_PAGE = gql`
  mutation ($id: ID!, $tagId: ID!) {
    addTagToSimulationLandingPage(id: $id, tagId: $tagId) {
      id
      tags {
        id
        label
        tagType {
          id
          label
        }
      }
    }
  }
`

export const REMOVE_TAG_FROM_LANDING_PAGE = gql`
  mutation ($id: ID!, $tagId: ID!) {
    removeTagFromSimulationLandingPage(id: $id, tagId: $tagId) {
      id
      tags {
        id
        label
        tagType {
          id
          label
        }
      }
    }
  }
`

export const UPDATE_TAG_TYPE = gql`
  mutation ($id: ID!, $label: String!, $slug: String!) {
    updateTagType(id: $id, label: $label, slug: $slug) {
      id
      label
      slug
    }
  }
`

export const UPDATE_TAG = gql`
  mutation ($id: ID!, $label: String!, $slug: String!) {
    updateTag(id: $id, label: $label, slug: $slug) {
      id
      label
      slug
      tagType {
        id
        label
        slug
      }
    }
  }
`
